export default "__VITE_ASSET__DQCDz5VU__"